export default {
  TOO_MANY_REQUESTS: 429,
};
